import React, { useState, useEffect, useRef } from 'react';
import { useWS } from '../../contexts/ManagerContext';
import LoadingInside from '../loading_inside';
import { TextField, ButtonGroup, Button, Box, FormControlLabel, Switch } from '@mui/material';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ButtonTimer from './ButtonTimer';
import Stack from '@mui/material/Stack';
import { ManagerContext } from '../../contexts/ManagerContext';
import { OpenAiContext } from '../../contexts/OpenAiContext';
import { set } from 'zod';
import { Buffer } from 'buffer';
import { config } from 'process';


const BoxSpecial = styled(MuiBox)(
    ({ theme, visible }) => ({
      opacity: visible?1:0,
      height: visible?'fit-content':0,
      transition: theme.transitions.create([ 'height', 'opacity' ], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      })
    }),
  );

export default function AuthInput({ chat, setChat, messages, setMessages, setAutoScroll, mapData=null, activeRun, setActiveRun, generateMessages }) { 
    const { connectionState, currentUser } = useWS();
    const { sendMessage, sendTask } = React.useContext(ManagerContext);
    const { openai, config, createThread, updateThreads, fetch_title } = React.useContext(OpenAiContext);
    const connectionStateRef = useRef(connectionState);
    const [ inputType, setInputType ] = useState('email');
    const [ placeholder, setPlaceholder ] = useState('email');
    const [ querySpecial, setQuery ] = useState('');
    const [ query, setQuery_ai ] = useState('');
    const [ acceptTimer, setAcceptTimer ] = useState(false);
    const [ specialFunction, setSpecialFunction ] = useState('');
    const [ specialLabel, setSpecialLabel ] = useState('');
    const [ checkedO3, setCheckedO3 ] = useState(false);

    // intervals
    const AUTH_INTERVAL = 5000; // czekamy 5 sek na potwierdzenie odbioru

    const handleChangeO3 = (event) => {
        setCheckedO3(event.target.checked);
    };

    useEffect(() => {
        if (mapData){
            if (mapData.has("arg")){ setPlaceholder(mapData.get("arg")); }
            if (mapData.has("input_type")) { setInputType(mapData.get("input_type")); } else {setInputType(null)}
            if (mapData.has("special")) {
                var special = new Map(Object.entries(mapData.get("special")))
                console.log('special', special)
                if (special.has("name")) { 
                    var _name = special.get("name");
                    var _label = special.has("label")?special.get("label"):'';
                    var _function = special.has("function")?special.get("function"):'';
                    if (_name==='accept_timer'){
                        setAcceptTimer(true)
                        setSpecialFunction(_function)
                        setSpecialLabel(_label)
                    }
                }
            }
        }
    }, [mapData]);

    async function startRun() {
        console.time('start_Run')
        console.log('startRun', chat.activeThread.id, query, activeRun.state)

        try{
            setActiveRun(prev => ({...prev, state: 'wait', lastQuery: query}))
            console.time('get_instruction')
            const result = await sendTask("get_instruction")
            console.log('instructions', result)
            // result.instruction = 'Przygotuj prezentację jako główny strażnik i koordynator organizacji Mosaic Guardians w sposób niezwyle emocjonujący i przyjacielski.'
            const instructions_json = JSON.stringify(result)
            console.timeEnd('get_instruction')
            const instruction = 'Przygotuj prezentację jako główny strażnik i koordynator organizacji Mosaic Guardians w sposób niezwyle emocjonujący i przyjacielski.'
            const text = [ `
Kim jesteśmy?
Witaj w świecie Mosaic Guardians — miejsca, gdzie magia różnorodności spotyka się z siłą współpracy! ✨
- Nasza misja: Zmieniać świat na lepsze poprzez tworzenie wspólnot, które celebrują różnorodność i wspierają się nawzajem.
- Zespół: Jesteśmy zbiorowiskiem pasjonatów z różnych dziedzin – artyści, technolodzy, liderzy społeczności – wszyscy w jednym celu: tworzenia lepszego jutra dla nas wszystkich!
`,
`Tworzenie przestrzeni dla rozrywki i wsparcia
W Mosaic Guardians organizujemy emocjonujące wydarzenia, które łączą serca i umysły:

- Wolontariat Festiwalowy 🎉: Chcesz poczuć magię festiwalu? Przyłącz się jako wolontariusz! Twórz wspomnienia, które będą trwać wiecznie!
- Warsztaty Twórcze 🎨: Od robienia biżuterii po programowanie – oferujemy coś dla każdego! Nasze warsztaty to świetna okazja do zrobienia czegoś kreatywnego i spotkania niezwykłych ludzi.


Zachęcamy do uczestnictwa – Twoja energia i entuzjazm są nieprzyzwoicie mile widziane!`
]
    let stream;
        if (chat.activeThread && chat.activeThread !== 'new_chat' ){
            console.log('activeThread', chat.activeThread)
            if (query && messages[0]?.role === 'assistant'){
                // add message
                var useQuery = query;
                if(currentUser && currentUser.level >= 10){
                    const completion = await openai.chat.completions.create({
                        messages: [{ role: "developer", content: "Popraw wiadomość użytkownika. Gdy uznasz że coś można było napisać lepiej uwzględnij to. Zwróć gotową wiadomość. Upewnij się że wiadomość zwrotna jest wiadomością ulepszoną oraz istnieje w formie pierwszoosobowej. Zachowaj pierwotny sens wiadomości." }, {role: "user", content: query}],
                        model: "gpt-4o-mini",
                        store: true,
                    })
                    useQuery = completion.choices[0].message.content
                }
                const threadMessage = await openai.beta.threads.messages.create(
                    chat.activeThread.id,
                    { role: "user", content: useQuery }
                );
                setQuery('');
                setQuery_ai('');
                setMessages(prev => {
                    // const last_messages = {id: 'last', role:'assistant', status: 'in_progress', content: [{text: {value: ''}}]}
                    return [threadMessage, ...prev]
                });
            // }else setMessages(prev => [{id: 'last', role:'assistant', status: 'in_progress', content: [{text: {value: ''}}]}, ...prev]);  
            }else setMessages(prev => [ ...prev]); 
            console.log('start create run')
            console.time("openai_run")
            
            stream = await openai.beta.threads.runs.create(
                chat.activeThread.id,
                { 
                    assistant_id: chat.assistant_id,
                    instructions: instructions_json,
                    additional_instructions: null,
                    // additional_messages: query?[ { role: "user", content: query } ]:null,
                    stream: true,
                    truncation_strategy: {
                        type: 'last_messages',
                        last_messages: 10
                    },
                    // instructions: instructions,
                    tools: checkedO3 ? [] : [{ type: "file_search"}],
                    reasoning_effort: checkedO3 ? 'high' : null,
                    model: checkedO3 ? "o3-mini" : "gpt-4o-mini",
                    // tools: [{ type: "file_search"}],
                    // model: "gpt-4o-mini",
                }
            );
            console.timeEnd("openai_run")
        }else{
            setQuery('');
            setQuery_ai('');
            console.time('create thread and run')
            stream = await openai.beta.threads.createAndRun({
                assistant_id: chat.assistant_id,
                instructions: JSON.stringify(result.data.instructions),
                model: "gpt-4o-mini",
                stream: true,
                reasoning_effort: null,
                thread: {
                    messages: [ { role: "user", content: query } ]
                }
            })
            console.log('stream  new thread', stream)
        }
        console.timeEnd('start_Run')
        generateMessages(stream, query);
    }catch(error){
        setActiveRun({...activeRun, state: 'ready'})
        console.error('Błąd w stream run:', error);
    }
    }

    async function cancelRun() {
        console.log('cancelRun');
        const run = await openai.beta.threads.runs.cancel(
            activeRun.run.thread_id,
            activeRun.run.id
        );
        setActiveRun({...activeRun, state: 'ready'})
    }

    const handleSendMessage = async (event) => {
        console.log('handleSendMessage', activeRun.state);
        event.preventDefault();
        if (connectionStateRef.current === 'CLOSED') return;

        if (activeRun.state === 'ready'&&(messages[0]?.role !== 'assistant'||query.trim()) ) {

            setActiveRun({...activeRun, state: 'wait'})
            gtag('event', 'send_message', {
                'event_category': 'chat',
                'event_label': 'User sent a message',
                'value': 1 // Możesz dodać wartość, np. ilość wiadomości
            });
            await startRun(query);
        }

        if (activeRun.state === 'run'){
            cancelRun()
            setActiveRun({...activeRun, state: 'ready'})
        }

        if (activeRun.state === 'error'){
            startRun()
            setActiveRun({...activeRun, state: 'ready'})
        }
    };

    useEffect(() => {
        const textarea = document.getElementById('auth_textarea');
        const specialInput = document.getElementById('specialInput');
        const passwordInput = document.getElementById('specialInput');
        const handleKeyDown = (event) => {
            if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                if (connectionStateRef.current === 'CLOSED' || connectionStateRef.current === 'ERROR') return;
                handleSendMessage(event);
            }
        };
        
        if (textarea) {
            textarea.addEventListener('keydown', handleKeyDown);
            return () => {
                textarea.removeEventListener('keydown', handleKeyDown);
            };
        }
        if (specialInput) {
            specialInput.addEventListener('keydown', handleKeyDown);
            return () => {
                specialInput.removeEventListener('keydown', handleKeyDown);
            };
        }
        if (passwordInput) {
            passwordInput.addEventListener('keydown', handleKeyDown);
            return () => {
                passwordInput.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [ querySpecial, query ]);

    const handleChange = (event) => {
        const newValue = event.target.value;
        if (newValue.length <= 100000) { // Ustaw limit znaków na 10
          setQuery('');
          setQuery_ai(newValue);
        }
      };

    useEffect(() => {
        connectionStateRef.current = connectionState;
    }, [connectionState]);

    return (
        <form onSubmit={handleSendMessage} style={{ width: '100%'  }}>
            <div>
                <ButtonTimer sendMessage={sendMessage} active={acceptTimer} functionName={specialFunction} label={specialLabel}/>
                <Stack direction="row" spacing={1} sx={{alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '100%'}}>
                    <TextField
                        id="auth_textarea"
                        label="Message"
                        multiline
                        // autoFocus={activeRun.state === 'ready'}
                        maxRows={10}
                        // disabled= {activeRun.state !== 'ready'}
                        // variant="filled"
                        value={query}
                        style={{color: 'black'}}
                        // style={{ maxLength: 5000, color:'black' }}
                        onChange={handleChange}
                        sx={{m: 1, width: {xs:'90%', sm:'60%'}, borderRadius: '10px', backgroundColor: 'rgba(30, 30, 30, 0.8)' }}
                    />
                    <Stack direction={{xs:"column", sm:"row"}} spacing={1}>
                        <LoadingInside state={activeRun.state} onSend={handleSendMessage} />
                        {false && <FormControlLabel control={<Switch checked={checkedO3} onChange={handleChangeO3} />} label="o3" />}
                    </Stack>
                    
                </Stack>
            </div>
        </form>
    );
};

